const isEBM = window.appConfig === 'ebm';

const routes =
{
    path: "/area-reserva",
    component: require("../pages/reserve-area/ReserveAreaWrapper.vue").default,
    children: [
        {
            path: "portal",
            name: "reserve-area-portal",
            component: require("../pages/reserve-area/InputCode.vue").default,
            meta: {
                title: isEBM ? 'Estoy bien Mamá - Área Personal' : 'Ahora vuelvo Mamá - Área Personal',
                meta_title: isEBM ? 'Estoy bien Mamá - Área Personal' : 'Ahora vuelvo Mamá - Área Personal',
                meta_description: isEBM
                    ? '¡Accede al área personal de Estoy bien mamá para gestionar todos tus viajes!'
                    : '¡Accede al área personal de Ahora Vuelvo mamá para gestionar todos tus viajes!',
                meta_keywords: isEBM
                    ? 'ÁREA PERSONAL, VIAJE, EXPERIENCIAS, ESTOY BIEN MAMÁ, DÍA, ÚNICAS, TAILANDIA, BALI'
                    : 'ÁREA PERSONAL, VIAJE, EXPERIENCIAS, AHORA VUELVO MAMÁ, DÍA, ÚNICAS, TAILANDIA, BALI',
            },

        },
        {
            path: ":code/formulario",
            name: "reserve-area-form",
            props: true,
            component: require("../pages/reserve-area/PassengersComponent.vue").default,
        },
        {
            path: ":code/resumen",
            name: "reserve-area-summary",
            component: require("../pages/reserve-area/ReserveSummary.vue").default,
        },
        {
            path: ":code/extras",
            name: "reserve-area-extras",
            component: require("../pages/reserve-area/ReserveExtras.vue").default,
        },
        {
            path: ":bonusCode/confirmacion",
            props: true,
            name: "reserve-area-comfirm",
            component: require("../pages/reserve-area/ReserveComfirm.vue").default,
        },
    ]
};

export default routes;
